import React, { memo } from "react"
import { Text, UnorderedList, ListItem, Flex } from "@chakra-ui/react"

import { useCore } from "@app/hooks/useCore"
import { useMedia } from "@app/hooks/useMedia"

import type { ProductCombinedProps } from "@root/types/global"

type Props = {
  product: ProductCombinedProps
}

export const ProductContentDescription: React.FC<Props> = memo(({ product }) => {
  const {
    helpers: { linebreak },
  } = useCore()
  const { isBase } = useMedia()

  // data for description/bullets falls into three types, with the additional need to split bullets into a different column
  // Unfortunately, we have to manipulate the raw html as best we can
  let desc = []
  let bullets = []
  if (product?.descriptionHtml) {
    desc = product.descriptionHtml.includes("<ul>") && !isBase ? product.descriptionHtml.split(/(?=<ul>)/g) : [product.descriptionHtml]
    desc = desc.map((item: string) => item.replace(/<[^/>][^>]*><\/[^>]+>/g, ""))
  } else if (Array.isArray(product?.description)) {
    desc = product?.description.filter(item => !item.listItem).map(item => item.children[0].text)
    bullets = product?.description.filter(item => item.listItem).map(item => item.children[0].text)
  }
  return (
    <Flex>
      {product?.descriptionHtml ? (
        <Flex flexDirection="column">
          {desc?.map((item: any, index: number) => {
            return (
              <Text
                key={`desc-${index}`}
                as="div"
                letterSpacing="generous"
                size="sm"
                color="grey.text"
                dangerouslySetInnerHTML={{ __html: item }}
                sx={{ "> ul br": { display: "none" } }}
              />
            )
          })}
        </Flex>
      ) : Array.isArray(product?.description) ? (
        <Flex w="100%">
          {desc?.map((item: any, index: number) => (
            <Text letterSpacing="generous" size="sm" pr="4" key={index} pb="4" color="grey.text">
              {item}
            </Text>
          ))}
          <UnorderedList marginInlineStart="15px !important" flex="1" lineHeight="2" letterSpacing="generous" color="grey.text">
            {bullets.map((item: any, index: number) => (
              <ListItem key={index} color="grey.text">
                {item}
              </ListItem>
            ))}
          </UnorderedList>
        </Flex>
      ) : product?.description ? (
        <>
          {product?.description && (
            <Text
              letterSpacing="generous"
              size="sm"
              dangerouslySetInnerHTML={{ __html: linebreak(product.description) || "" }}
              color="grey.text"
            />
          )}
        </>
      ) : null}
    </Flex>
  )
})
